import { API_RETRY_SCHEDULED, API_RETRY_SUCCEEDED } from '@app/actions/api-connectivity';

const initialState = {
  connected: true,
};

const apiConnectivity = (state = initialState, action) => {
  switch (action.type) {
    case API_RETRY_SCHEDULED:
      return {
        connected: false,
      };
    case API_RETRY_SUCCEEDED:
      return {
        connected: true,
      };
    default:
      return state;
  }
};

export default apiConnectivity;



// WEBPACK FOOTER //
// ./src/reducer/api-connectivity.js